module.exports = __webpack_public_path__ + "static/media/comete-coco.c22ad824.jpg";